import type { SxProps, Theme } from '@mui/material/styles';

import { TOAST_EASING, TOAST_ENTER_MS } from '../../molecules/Toast';

/** Clearance for the mobile offline banner, which owns the top of the screen. */
export const MOBILE_TOP_INSET_PX = 12;
export const DESKTOP_INSET_PX = 24;
export const DESKTOP_WIDTH_PX = 400;

export const viewportSx =
  (placement: 'bottom' | 'top', height: number): SxProps<Theme> =>
  (theme) => ({
    position: 'fixed',
    // Only the cards take pointer events — the container must not swallow
    // clicks on the page behind it.
    pointerEvents: 'none',
    zIndex: theme.zIndex.snackbar,
    height: `${height}px`,
    transition: `height ${TOAST_ENTER_MS}ms ${TOAST_EASING}`,
    ...(placement === 'bottom'
      ? {
          bottom: `${DESKTOP_INSET_PX}px`,
          right: `${DESKTOP_INSET_PX}px`,
          width: `min(${DESKTOP_WIDTH_PX}px, calc(100vw - ${DESKTOP_INSET_PX * 2}px))`,
        }
      : {
          top: `calc(${MOBILE_TOP_INSET_PX}px + env(safe-area-inset-top, 0px))`,
          left: `${MOBILE_TOP_INSET_PX}px`,
          right: `${MOBILE_TOP_INSET_PX}px`,
          width: 'auto',
        }),
  });
